import styled from 'styled-components'

import { Typography } from '../typography'
import { InfoIcon } from 'primsell-shared-layer/assets/icons'

export const InputLabel = styled.div`
  margin-bottom: 8px;
`

export const LabelMark = styled(Typography)`
  color: #ef2738;
  line-height: 16px;
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`

export const TooltipIcon = styled(InfoIcon)`
  margin-left: 4px;
  width: 16px;
  height: 16px;
`

export const RightHelperTextTypography = styled(Typography)`
  margin-left: auto;
  flex-shrink: 0;
`
